/**
 * KpiToggle — a small segmented button group that swaps which metric a card shows
 * (e.g. Response Time | Time to Connect on the Main Dashboard).
 *
 * Same look as the corporate dashboard's cd-kpi-selector, as a shared component on
 * theme tokens. Buttons carry aria-pressed, and the group is labelled for screen readers.
 *
 * @param {{ key: string, label: string }[]} options
 * @param {string}   value     — the active option's key
 * @param {(key: string) => void} onChange
 * @param {string}   label     — accessible name for the group ("Metric")
 */
import './kpi-toggle.css';

const KpiToggle = ({ options, value, onChange, label = 'Metric' }) => (
    <div className="kpi-toggle" role="group" aria-label={label}>
        {options.map((o) => (
            <button
                key={o.key}
                type="button"
                className={`kpi-toggle__btn${value === o.key ? ' is-active' : ''}`}
                aria-pressed={value === o.key}
                onClick={() => onChange(o.key)}
            >
                {o.label}
            </button>
        ))}
    </div>
);

export default KpiToggle;
